import "./MoreInformation.css";

export const BadLeaver = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">Bad leaver</text>
      <text className="paragraph">
        A "bad leaver" is a term commonly used in founder vesting agreements to
        describe a founder who leaves the company under circumstances that are
        deemed to be detrimental to the company.
      </text>
      <text className="paragraph">
        The reason why a distinction is made between good, early and bad leaver,
        is because, typically a different price is agreed upon for the shares. A
        good leaver is typically treated better than an early leaver and early
        leaver is typically treated better than a bad leaver.
      </text>
    </div>
  </div>
);
